import React from 'react';
import AddReceivedEntryFunctional from './components/add-received-entry-functional';
import './styles.scss';

const AddReceivedEntry = ({ state, setState, refreshList }) => {
	return <AddReceivedEntryFunctional {...{ state, setState, refreshList }} />;
};

export default AddReceivedEntry;
